import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input, Dropdown, Menu, Icon, DatePicker } from 'antd'

// icon
import { FaUpload } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/qbmedia/actions'
// import { DownOutlined, UserOutlined } from '@ant-design/icons';

const { Search } = Input

const { MonthPicker, RangePicker } = DatePicker

class HeadBar extends Component {
    state = {
        begin_time: 0,
        end_time: 0,
        range_time: [],
        type_search: '',
        display_type: 'Toàn bộ trường dữ liệu'
    }
    _handleAddClick = () => {
        this.props.setDefaultCurrentMedia()
        this.props.showModalCurrentMediaInfo()
    }
    onChangeTime = e => {
        this.setState({ range_time: e })
        if (e && e.length > 0) {
            const starttime = (e[0]._d.valueOf() / 1000) >> 0
            const endtime = (e[1]._d.valueOf() / 1000) >> 0
            this.setState({ begin_time: starttime, end_time: endtime })
            this.props.updateParamSearch(starttime, endtime, '')
        } else {
            this.setState({ begin_time: 0, end_time: 0 })
            this.props.updateParamSearch(0, 0, '')
        }


    }
    render() {
        const menu = (
            <Menu onClick={e => {
                if (e.key !== '0') {

                    this.setState({ type_search: e.key, display_type: e.item.props.children })
                    this.props.updateParamSearch(0, 0, e.key)
                } else {
                    this.setState({ type_search: '', display_type: e.item.props.children })
                    this.props.updateParamSearch(0, 0, '')
                }

            }}>
                <Menu.Item key="0" icon={<Icon type="user" />}>
                    Toàn bộ trường dữ liệu
                </Menu.Item>
                <Menu.Item key="TypeSearchMediaHastag" icon={<Icon type="user" />}>
                    HashTag
                </Menu.Item>
                <Menu.Item key="TypeSearchMediaName" icon={<Icon type="user" />}>
                    Tên tài liệu
                </Menu.Item>
                <Menu.Item key="TypeSearchMediaContent" icon={<Icon type="user" />}>
                    Nội dung tài liệu
                </Menu.Item>

            </Menu>
        );
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this._handleAddClick()}
                    >
                        <FaUpload className="iconButton" />
                        Upload tài liệu
                    </Button>
                </div>
                <div>
                    <RangePicker
                        format="DD/MM/YYYY"
                        renderExtraFooter={() =>
                            'Hiển thị biểu đồ theo thời gian'
                        }
                        val
                        onChange={this.onChangeTime}
                        value={this.state.range_time}
                        placeholder={[
                            'Thời gian đầu',
                            'Thời gian cuối',
                        ]}
                        showTime
                        // disabled={this.props.textSearch === ''}
                        style={{ marginRight: 20 }}
                    />
                    <Dropdown overlay={menu}>
                        <Button style={{ height: 32, marginRight: 20 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: 'center' }}>
                                <text>{this.state.display_type}</text>
                                <Icon style={{ marginLeft: 10 }} type="down" />
                                {/* <DownOutlined style={{ marginLeft: 10 }} /> */}
                            </div>

                        </Button>
                    </Dropdown>

                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => {
                            this.props.searchMedia(this.state.begin_time, this.state.end_time, this.state.type_search)

                        }}
                        onChange={e => {
                            if (e.target.value === '') {
                                this.setState({ begin_time: 0, end_time: 0 })
                                this.props.updateParamSearch(0, 0, '')
                                this.setState({ range_time: [] })
                                // this.props.loadListMedias({
                                //     page_number: 1,
                                //     page_size: 24,
                                //     status: 0,
                                // })
                                this.props.updateCurrentTextSearch(
                                    e.target.value
                                )
                            } else {
                                this.props.updateCurrentTextSearch(
                                    e.target.value
                                )
                            }
                        }}
                    // value={this.props.textSearch}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.qbmedia.textSearch,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showModalCurrentMediaInfo: () => {
            dispatch(mediaActions.action.showModalCurrentMediaInfo())
        },
        setDefaultCurrentMedia: () => {
            dispatch(mediaActions.action.setDefaultCurrentMedia())
        },
        updateCurrentTextSearch: textSearch => {
            dispatch(mediaActions.action.updateTextSearch(textSearch))
        },
        searchMedia: (begin, end, type) => {
            dispatch(mediaActions.action.searchMedia(begin, end, type))
        },
        loadListMedias: params => {
            dispatch(mediaActions.action.loadListMedias(params))
        },
        updateParamSearch: (begin, end, type) => {
            dispatch(mediaActions.action.updateParamSearch(begin, end, type))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeadBar)
